import React from "react";
import "../pages/Experience.css";


export const JobCard = ({ position, company, date, description }) => {
  return (
    <div className="job-card">
      <div className="experience-container">
        <div>
          <h2 className="job-position">{position}</h2>
        </div>
        <div className="experience-company">
          <p className="job-company">{company}</p>
          <p className="job-date">{date}</p>
        </div>
      </div>

      <p className="job-description">{description}</p>
    </div>
  );
};
